import { all, takeEvery, put, fork } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actions from './actions';

function* redirectTo(action){
  yield(put(push(action.url)));
}

export function* watchRedirectTo() {
  yield takeEvery(actions.REDIRECT_TO, redirectTo);
}


export default function* rootSaga() {
  yield all([
    fork(watchRedirectTo)
  ]);
}